import request from "../utils/request";

export function companyComplaintsPerStatus(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/complaintsPerStatus/?${query}`,
    method: "get",
  });
}

export function companyDSARPerStatus(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/dsarPerStatus/?${query}`,
    method: "get",
  });
}

export function companyComplaintsPerCompanyAndStatus() {
  return request({
    url: `/charts/complaintsPerCompanyAndStatus`,
    method: "get",
  });
}

export function companyDSARPerReceivingMeans(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/dsarPerReceivingMeans?${query}`,
    method: "get",
  });
}

export function companyDSARPerClosure(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/dsarPerClosure?${query}`,
    method: "get",
  });
}

export function companyDSARPerRequirementType(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/dsarPerRequirementType?${query}`,
    method: "get",
  });
}

export function companyComplaintsTimeBoxPlot(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/complaintsTimeBoxplot?${query}`,
    method: "get",
  });
}

export function companyDSARTimeBoxPlot(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/dsarTimeBoxplot?${query}`,
    method: "get",
  });
}

export function companyOmbudsmanTimeBoxPlot(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/ombudsmanTimeBoxplot?${query}`,
    method: "get",
  });
}

export function companyRequirementsDashboard(id) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/requirements/?${query}`,
    method: "get",
  });
}

export function companyClassificationChart(id, type, classification) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/classificationChart/${type}/${classification}/?${query}`,
    method: "get",
  });
}

export function companyStatusChart(id, type) {
  let query = "";
  if (id) {
    query += `company=${id}`;
  }
  return request({
    url: `/charts/status/${type}/?${query}`,
    method: "get",
  });
}

export function getComplaintsByCompanyAndStatus() {
  return request({
    url: `/charts/complaintsPerCompanyAndStatus`,
    method: "get",
  });
}

// Root Dashboard APIs
export function getComplaintsPerStatus() {
  return request({
    url: "/charts/per-status",
    method: "get",
  });
}

export function getUntriagedComplaints(companyId) {
  return request({
    url: "/charts/untriagedComplaints",
    method: "get",
    params: { companyId },
  });
}

export function getProcessingComplaints(companyId) {
  return request({
    url: "/charts/processingComplaints",
    method: "get",
    params: { companyId },
  });
}

export function getComplaintsWithViews(companyId) {
  return request({
    url: "/charts/complaintsWithViews",
    method: "get",
    params: { companyId },
  });
}

export function getInactiveComplaints(companyId) {
  return request({
    url: "/charts/inactiveComplaints",
    method: "get",
    params: { companyId },
  });
}

export function getOverduePendencies(companyId) {
  return request({
    url: "/charts/overduePendencies",
    method: "get",
    params: { companyId },
  });
}

export function getOverdueOmbudsman(companyId) {
  return request({
    url: "/charts/overdueOmbudsman",
    method: "get",
    params: { companyId },
  });
}

export function getOverdueDsar(companyId) {
  return request({
    url: "/charts/overdueDsar",
    method: "get",
    params: { companyId },
  });
}

export function getComplaintsPerMonth(companyId, year) {
  const params = {};
  if (companyId) {
    params.company = companyId;
  }
  if (year) {
    params.year = year;
  }
  return request({
    url: `/charts/complaintsOverTime`,
    method: "get",
    params,
  });
}

export function getMentionedUsers(companyId) {
  return request({
    url: "/charts/mentionedUsers",
    method: "get",
    params: { companyId },
  });
}

export function getUnviewedComplaintsForUser(companyId) {
  const params = {};
  if (companyId) {
    params.companyId = companyId;
  }
  return request({
    url: "/charts/unviewedComplaintsForUser",
    method: "get",
    params,
  });
}
